import request from '@/utils/request';

//获取最新招募信息
export function pltvolunteerRecruit(data) {
  return request({
    url: '/wx/recruit/selectPltvolunteerRecruit.do',
    method: 'post',
		data
  })
}

//获取招募字典信息
export function volunteerDic(data) {
  return request({
    url: '/wx/recruit/toVolunteerDic.do',
    method: 'post',
		data
  })
}
//志愿者招募报名
export function VolunteerRegister(data) {
  return request({
    url: '/wx/signup/toRegister.do',
    method: 'post',
		data
  })
}

//获取章程制度
export function getArticleItems(data) {
  return request({
    url: '/wx/volSys/findVolunteerSystem.do',
    method: 'post',
		data
  })
}

//获取通知信息
export function queryArticleItems(data) {
  return request({
    url: '/wx/volSys/toSystemSee.do',
    method: 'post',
		data
  })
}
//查看通知
export function findInfoById(data) {
  return request({
    url: '/wx/volSys/findVolunteerSystemById.do',
    method: 'post',
		data
  })
}

//获取荣誉（type）
export function getHonours(data) {
  return request({
    url: '/wx/volHonor/getVolunteerHonor.do',
    method: 'post',
		data
  })
}

//获取照片墙
export function getVolunteerImgs(data) {
  return request({
    url: '/wx/volunteerImg/getVolunteerImg.do',
    method: 'post',
		data
  })
}

//图片点赞
export function admireImg(data) {
  return request({
    url: '/wx/volunteerImg/addImgDetail.do',
    method: 'post',
		data
  })
}

//精选留言
export function getWonderfulMessage(data) {
  return request({
    url: '/wx/volQuestion/getPltVolunteerQuestion.do',
    method: 'post',
		data
  })
}

//展厅答疑
export function  leaveMessage(data) {
  return request({
    url: '/wx/volQuestion/addPltVolunteerQuestion.do',
    method: 'post',
		data
  })
}



// WEBPACK FOOTER //
// ./src/api/article.js